<!-- Modal -->
<template>
    <div class="modal fade" id="createPermissionGroupModal" ref="createPermissionGroupModal" tabindex="-1" aria-labelledby="createLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<form @submit.prevent="savePermissionGroup">
						<div class="modal-header align-items-baseline">
                            <div>
                                <h5 class="modal-title" id="exampleModalLabel">Add new permission group</h5>
                            </div>
							<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						</div>
						<div class="modal-body">
							<div class="form-group mb-3">
								<label for="name">Name</label>
								<input type="text" v-model="permissionGroup.name" placeholder="Enter permission group name" class="form-control" required />
							</div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
							<button type="submit" class="btn btn-primary">Save</button>
						</div>
					</form>
				</div>
			</div>
		</div>
</template>
<script>

import { Modal } from "bootstrap";
import juniperApi from '@/api/juniperApi'

export default {
    name: "CreatePermissionGroupModal",
    components: {
    },
    emits: ["permissionGroupSaved"],
    data: () => ({
        modal: null,
        permissionGroup: {name: ''},
    }),
    mounted() {
        this.modal = new Modal(this.$refs.createPermissionGroupModal);
        
        let createPermissionGroupModal = document.getElementById("createPermissionGroupModal");
        
        let self = this;
        
        createPermissionGroupModal.addEventListener("hidden.bs.modal", function () {
            
            self.permissionGroup = {
                name: '',
			};
        });
    },
    methods: {
        showModal: async function (value) {
            if (value) {
                this.modal.show();
            }
        },
		async savePermissionGroup () {

            try {
                await juniperApi.post(`/permission-groups`, this.permissionGroup);

                this.$swal.fire({
                    icon: 'success',
                    title: 'Permission group created successfully!',
                    timer: 4000,
                });

                this.modal.hide();
                this.$emit("permissionGroupSaved");

            } catch (error) {
                    let message = ''
                if (error.response.data.error) {
                    for (const [key, value] of Object.entries(error.response.data.error)) {
                        console.log(key)
                        message += ` ${value} \n`
                    }
                }
                this.$swal.fire({
                    icon: 'error',
                    title: message,
                    timer: 6000,
                })
            }
		},
    },
    props: {
    },
};
</script>
